export const codeBlockLightGray = '#f6f8fa';
